import { GetDashboardDataConst } from "../constant/DashboardConstant";

const initDashboard = {
    dashboardData: null,
};

const DashboardReducer = (state = initDashboard, action) => {
    switch (action.type) {
        case GetDashboardDataConst:
            return { ...state, dashboardData: action.payload };
        default:
            return state;
    }
};

export default DashboardReducer;
